var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcuador(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da352e",
    d: "M30 24H0v-6h30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f4c9e",
    d: "M0 12h30v6H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fadf4b",
    d: "M30 12H0V0h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    d: "M20 14a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-3c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#034ea2",
    d: "M19 13c0 1.1-.9 3-2 3h-4c-1.1 0-2-1.9-2-3v-1c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1c23",
    d: "M18 13c0 1.1-.9 3-2 3h-2c-1.1 0-2-1.9-2-3v-1c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6dbe46",
    d: "M16.97 9.14c-.13.48-.96.86-1.97.86s-1.84-.38-1.97-.86c-1.2.17-1.03.49-1.03.86 0 .55.8 1 3 1s3-.45 3-1c0-.37.18-.7-1.03-.86"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6d388",
    d: "M16 14a1 1 0 1 1-2 0v-3a1 1 0 0 1 2 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M18.5 7q.66 0 1.25.14C19.12 6.06 17 5 15 7c-2-2-4.12-.94-4.75.14Q10.85 7 11.5 7c1.93 0 3.5.9 3.5 2 0-1.1 1.57-2 3.5-2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ed2e7",
    d: "M15 16c1.1 0 2-1.57 2-3.5S16.1 9 15 9s-2 1.57-2 3.5.9 3.5 2 3.5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#6dbe46",
    d: "M14.5 12q-.81.01-1.5.35v.15c0 1.93.9 3.5 2 3.5 1 0 1.82-1.3 1.97-2.98A3.5 3.5 0 0 0 14.5 12"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M15 18c1.66 0 3-.45 3-1s-1.34-1-3-1-3 .45-3 1 1.34 1 3 1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#034ea2",
    d: "M17 18c0 .83-.9 1-2 1s-2-.17-2-1 .9-2 2-2 2 1.17 2 2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1c23",
    d: "M14 18c0-.83.45-2 1-2s1 1.17 1 2-.45 1-1 1-1-.17-1-1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccd6dd",
    d: "M14 6c0-.55.45 0 1 0s1-.55 1 0a1 1 0 0 1-2 0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 13c.55 0 1-.22 1-.5s-.45-.5-1-.5-1 .22-1 .5.45.5 1 .5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#c1694f",
    d: "M10 11c.55 0 1-.22 1-.5s-.45-.5-1-.5-1 .22-1 .5.45.5 1 .5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#c1694f",
    d: "M11 9c.55 0 1-.22 1-.5s-.45-.5-1-.5-1 .22-1 .5.45.5 1 .5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#c1694f",
    d: "M20 11c.55 0 1-.22 1-.5s-.45-.5-1-.5-1 .22-1 .5.45.5 1 .5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#c1694f",
    d: "M19 9c.55 0 1-.22 1-.5s-.45-.5-1-.5-1 .22-1 .5.45.5 1 .5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcuador);
export default __webpack_public_path__ + "static/media/ecuador.3e2c380cc78ce782090b8bc27c44246e.svg";
export { ForwardRef as ReactComponent };